import React, {useEffect, useState} from 'react'
import moment from "moment";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import {CartesianGrid, Line, LineChart, ReferenceArea, ResponsiveContainer, Tooltip, XAxis, YAxis,} from 'recharts';

const AtlasChart = ({header, initialData, dataKeys, yLegend, prepData}) => {
  console.log('initial',initialData)
  console.log('a', prepData)
  initialData = prepData

  const [data, setData] = useState(initialData)
  const [left, setLeft] = useState('dataMin')
  const [right, setRight] = useState('dataMax')
  const [refAreaLeft, setRefAreaLeft] = useState('')
  const [refAreaRight, setRefAreaRight] = useState('')
  const [top, setTop] = useState('dataMax+1')
  const [bottom, setBottom] = useState('dataMin-1')
  const [top2, setTop2] = useState('dataMax+20')
  const [bottom2, setBottom2] = useState('dataMin-20')

  useEffect(() => {
    console.log('reload')
  }, [])
  const dateFormatter = date => {
    return moment.unix(date).format('MMM YYYY');
  };

  const decimalFormatter = value => {
    return value && value.toFixed(2);
  };

  const findIndex = (trendTime) => {
    return initialData.findIndex(row => row?.trendTime === trendTime);
  }

  const getAxisYDomain = (from, to, ref, offset) => {
    const dataLocal = [...initialData]
    const refData = dataLocal.slice(findIndex(from) - 1, findIndex(to));
    let [bottom, top] = [refData[0][ref], refData[0][ref]];
    refData.forEach((d) => {
      if (d[ref] > top) top = d[ref];
      if (d[ref] < bottom) bottom = d[ref];
    });

    return [(bottom | 0) - offset, (top | 0) + offset];
  };

  const zoom = () => {
    let localRefAreaLeft = refAreaLeft;
    let localRefAreaRight = refAreaRight;

    if (refAreaLeft === refAreaRight || refAreaRight === '') {
      setRefAreaLeft('')
      setRefAreaRight('')
      return;
    }

    // xAxis domain
    if (refAreaLeft > refAreaRight) [localRefAreaLeft, localRefAreaRight] = [refAreaRight, refAreaLeft];

    // yAxis domain
    const [localBottom, localTop] = getAxisYDomain(localRefAreaLeft, localRefAreaRight, 'result', 1);
    // const [localBottom2, localTop2] = getAxisYDomain(localRefAreaLeft, localRefAreaRight, 'impression', 50);

    setRefAreaLeft('')
    setRefAreaRight('')
    setData(data?.slice())
    setLeft(localRefAreaLeft)
    setRight(localRefAreaRight)
    setBottom(localBottom)
    setTop(localTop)
    // setBottom2(localBottom2)
    // setTop2(localTop2)
  }

  const zoomOut = () => {
    setData(initialData.slice())
    setRefAreaLeft('')
    setRefAreaRight('')
    setLeft('dataMin')
    setRight('dataMax')
    setBottom('dataMin')
    setTop('dataMax+1')
    setBottom2('dataMin+50')
    setTop2('dataMax+50')
  }
  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h4" gutterBottom component="div">
          {header}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <div className="highlight-bar-charts" style={{userSelect: 'none', width: '100%'}}>
          <button type="button" className="btn update" onClick={() => zoomOut()}>
            Zoom Out
          </button>

          <ResponsiveContainer width="100%" height={400}>
            <LineChart
              width={800}
              height={400}
              data={data}
              onMouseDown={(e) => setRefAreaLeft(e.activeLabel)}
              onMouseMove={(e) => refAreaLeft && setRefAreaRight(e.activeLabel)}
              // eslint-disable-next-line react/jsx-no-bind
              onMouseUp={() => zoom()}
            >
              <CartesianGrid strokeDasharray="3 3"/>
              <XAxis allowDataOverflow
                     dataKey='trendTime'
                     domain={[left, right]}
                     type="number"
                     label={{value: 'Date', position: 'insideBottom', offset: 10, dy: 10}}
                     scale='time'
                     tickFormatter={dateFormatter}/>
              <YAxis allowDataOverflow
                     tickLine={{stroke: 'green'}}
                     domain={[bottom, top]}
                     type="number"
                     label={{value: yLegend, position: 'insideLeft', offset: 10, dy: 10}}
                     tickFormatter={decimalFormatter}
                     yAxisId="1"/>
              <Tooltip labelFormatter={(dt) => moment.unix(dt).format('DD-MMM-YYYY')}/>
              <Line yAxisId="1" type="natural" dataKey="result" stroke="green" dot={false} />
              {dataKeys.length > 0 && dataKeys.map((element, index) => {
                  return (<Line key={index} yAxisId="1" type="natural" dataKey={`${element.key}`} stroke={`${element.color}`} dot={false}/>)
                }
              )}
              {/*<Line yAxisId="1" type="natural" dataKey="goodMarket" stroke="red" dot={false} />)*/}
              {/*<Line yAxisId="1" type="natural" dataKey="bottom" stroke="blue" dot={false} />)*/}

              {refAreaLeft && refAreaRight ? (
                <ReferenceArea yAxisId="1" x1={refAreaLeft} x2={refAreaRight} strokeOpacity={0.3}/>
              ) : null}
            </LineChart>
          </ResponsiveContainer>
        </div>
      </Grid>
    </>
  )
}

export default AtlasChart;